<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="frame132" /> <a href="#">{{ name }}<i class="el-icon-arrow-down" /> </a>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh">
        中文
      </el-dropdown-item>
      <el-dropdown-item command="en">
        English
      </el-dropdown-item>
      <!-- <el-dropdown-item :disabled="language==='es'" command="es">
        Español
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='ja'" command="ja">
        日本語
      </el-dropdown-item> -->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
    inject: ['reload'],
   data() {
     return {
       modules: [],
      //  name: 'English',
       userName: this.$store.getters.name
     }
   },
  computed: {
    language() {
      return this.$store.getters.language
    },
    currentLanguage() {
       return this.$store.getters.language;
    },
    name() {
      return this.currentLanguage === 'en' ? 'English' : '中文';
    }
  },
  created() {
     this.modules = localStorage.getItem('modules')
     if (this.$route.path === '/globalLogin') {
       this.clickSetLanguageen()
     }
     if (this.modules) {
        if (this.userName === 'overseas' || this.modules.indexOf('multi:language') !== -1) {
       this.clickSetLanguageen()
     } else {
       this.clickSetLanguagezh()
     }
     }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.reload()
          this.$forceUpdate()
      this.$store.dispatch('app/setLanguage', lang)
      if (lang === 'en') {
         this.$message({
          message: 'Switch Language Success',
          type: 'success'
         })
         localStorage.setItem('lang', 'en')
      } else if (lang === 'zh') {
         this.$message({
          message: '切换为中文',
          type: 'success'
        })
        localStorage.setItem('lang', 'zh')
        console.log(this.$store.getters.language)
      }
    },
    clickSetLanguageen() {
      const setLanguage = 'en'
      this.$i18n.locale = setLanguage
      this.$store.dispatch('app/setLanguage', setLanguage)
      if (setLanguage === 'en') {
         console.log(this.$store.getters.language)
         localStorage.setItem('lang', 'en')
      } else if (setLanguage === 'zh') {
        localStorage.setItem('lang', 'zh')
        console.log(this.$store.getters.language)
      }
    },
    clickSetLanguagezh() {
       const setLanguage = 'zh'
      this.$i18n.locale = setLanguage
      this.$store.dispatch('app/setLanguage', setLanguage)
      if (setLanguage === 'en') {
         console.log(this.$store.getters.language)
         localStorage.setItem('lang', 'en')
      } else if (setLanguage === 'zh') {
        localStorage.setItem('lang', 'zh')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
a{
  font-size: 12px;
  color: #333;
}
.svg-icon{
  color: #333 !important;
  padding-top: 2px;
}
</style>
